import { ws } from "../../../utils/common";

export const createAssociationWS = async ({ body }) => {
    //Creo associazione
    const res = await ws(
        "POST",
        process.env.REACT_APP_ENDPOINT + "association/",
        null,
        body,
        true
    );

    if (res.error) {
        throw res.data;
    } else {
        return res.data.message;
    }
}
